module.exports = __webpack_public_path__ + "img/finantial-lease-header.b8dee913.jpg";